import React from "react";

const RequiredField = ({ children }) => (
  <span>
    {children}
    <span className="cps-color-primary">*</span>
  </span>
);

export default RequiredField;
